// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"886d4645","735":"2ccc0a63"}[chunkId] + ".chunk.js";
};